/**
 * Get Mapbox access token for Plotly mapbox plots (scattermapbox, choroplethmapbox, densitymapbox)
 * Checks environment variable and window global as fallback
 */
export function getMapboxAccessToken(): string {
  if (typeof window === 'undefined') return '';
  try {
    // Check for environment variable (Vite)
    const env = (import.meta as any).env;
    if (env && env.VITE_MAPBOX_ACCESS_TOKEN) return env.VITE_MAPBOX_ACCESS_TOKEN;
    // Check for window global (fallback)
    if ((window as any).__MAPBOX_TOKEN__) return (window as any).__MAPBOX_TOKEN__;
    return '';
  } catch {
    return '';
  }
}

/**
 * Merge mapbox token into Plotly config object
 * Preserves existing config properties
 */
export function mergeMapboxConfig(config: any = {}): any {
  const token = getMapboxAccessToken();
  return {
    ...config,
    mapboxAccessToken: token || config.mapboxAccessToken || '',
  };
}









